/**
 * GENERATED — do not edit.
 *
 * Source: @oylo/schema (filter effect) + src/schemas/overlay/.
 * Regenerate with `pnpm schema:gen`. tests/schema/drift.test.js gates this file.
 */
export default {
	type: 'object',
	properties: {
		brightness: {
			type: 'number',
			minimum: 0,
			maximum: 4,
			step: 0.1,
			initial: 1,
			tip: 'Brightness',
			formatter: 'dec1',
			kind: 'range',
			icon: 'ms/sunny',
			tooltip: {
				heading: 'Brightness',
				body: 'Adjusts the overall brightness.',
			},
		},
		contrast: {
			type: 'number',
			minimum: 0,
			maximum: 5,
			step: 0.1,
			initial: 1,
			tip: 'Contrast',
			formatter: 'dec1',
			kind: 'range',
			icon: 'ms/contrast',
			tooltip: {
				heading: 'Contrast',
				body: 'Controls the difference between light and dark areas.',
			},
		},
		hue_rotate: {
			type: 'number',
			minimum: -180,
			maximum: 180,
			step: 1,
			initial: 0,
			label: 'Hue',
			tip: 'Hue',
			unit: '°',
			wrap: true,
			kind: 'range',
			natural_step: 10,
			icon: 'ms/palette',
			tooltip: {
				heading: 'Hue Rotation',
				body: 'Rotates colors around the color wheel. Use this to quickly change the tone.',
			},
		},
		saturate: {
			type: 'number',
			minimum: 0,
			maximum: 10,
			step: 0.1,
			initial: 1,
			label: 'Saturation',
			tip: 'Saturation',
			formatter: 'dec1',
			kind: 'range',
			icon: 'ms/salinity',
			tooltip: {
				heading: 'Saturation',
				body: 'Adjusts color intensity. Above 1 means more vivid, below 1 means more muted.',
			},
		},
		sepia: {
			type: 'number',
			minimum: 0,
			maximum: 1,
			step: 0.1,
			initial: 0,
			tip: 'Sepia',
			formatter: 'dec1',
			kind: 'range',
			tooltip: {
				heading: 'Sepia',
				body: 'Applies a warm, brownish tone to the video for a vintage photograph look.',
			},
		},
		blur: {
			type: 'number',
			minimum: 0,
			maximum: 30,
			step: 1,
			initial: 0,
			tip: 'Blur',
			unit: 'px',
			kind: 'range',
			icon: 'ms/blur_on',
			tooltip: {
				heading: 'Blur',
				body: 'Applies gaussian blur to soften the image.',
			},
		},
		invert: {
			type: 'number',
			minimum: 0,
			maximum: 1,
			step: 0.1,
			initial: 0,
			tip: 'Invert',
			kind: 'range',
			tooltip: {
				heading: 'Invert',
				body: 'Inverts the colors of the video, creating a negative effect. The transition values lower the contrast, 0.5 results in flat gray.',
			},
		},
		posterize: {
			type: 'integer',
			minimum: 1,
			maximum: 8,
			step: 1,
			initial: 8,
			label: 'Posterize',
			tip: 'Posterize',
			kind: 'range',
			icon: 'ms/gradient',
		},
	},
	label: 'Filters',
}
